export enum UserServiceError {
  PasswordTimeoutException = 34015,
  EmailTimeoutException = 34016,
  EmailTooManyTimeoutException = 34017,
  UserEmailAlreadyExistsException = 34010,
  UserEmailAlreadyConfirmedException = 34011,
  ConfirmationTokenInvalid = 34012,
  ConfirmationTokenExpired = 34013,
  RestrictedCountryException = 34004,
}
